module.exports = __webpack_public_path__ + "static/media/ul-logo-charcoal.37d561eb.svg";